import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from 'components/ui/general/Button';

const IconWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    padding: 0 10px 0 0;
`;

const TitleWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    color: inherit;
`;

const disabledColor = 'rgba(0, 0, 0, 0.3)';

const ActionButton = (props) => {
    const {
        icon,
        title,
        onClick,
        disabled,
        style,
    } = props;

    return (
        <Button
            disabled={ disabled }
            onClick={ onClick }
            style={ style }
        >
            { icon &&
                <IconWrapper>
                    { disabled
                        ? React.cloneElement(icon, {
                            color: disabledColor,
                        })
                        : icon
                    }
                </IconWrapper>
            }

            <TitleWrapper>
                { title }
            </TitleWrapper>
        </Button>
    );
};

ActionButton.defaultProps = {
    disabled: false,
    icon: null,
    onClick: () => {},
    style: {},
    title: '',
};

ActionButton.propTypes = {
    disabled: PropTypes.bool,
    icon: PropTypes.node,
    onClick: PropTypes.func,
    style: PropTypes.object,
    title: PropTypes.string,
};

export default ActionButton;



// WEBPACK FOOTER //
// ./src/components/button/ActionButton.js